import type { IwTeam } from "../../../features/infinite-war";
import { pauseHtml, resultHtml } from "./markup";
import type { InfiniteWarHudHandlers, InfiniteWarHudMode } from "./types";

export function renderMenuModal(
  modal: HTMLElement,
  mode: Exclude<InfiniteWarHudMode, "play">,
  winner: IwTeam | null,
  handlers: Pick<InfiniteWarHudHandlers, "onResume" | "onRestart" | "onQuit">,
): void {
  modal.hidden = false;
  modal.style.pointerEvents = "auto";
  if (mode === "paused") {
    modal.innerHTML = pauseHtml();
    modal.querySelector("[data-resume]")?.addEventListener("click", (ev) => {
      ev.stopPropagation();
      handlers.onResume();
    });
  } else {
    modal.innerHTML = resultHtml(winner ?? "south");
  }
  modal.querySelector("[data-restart]")?.addEventListener("click", (ev) => {
    ev.stopPropagation();
    handlers.onRestart();
  });
  modal.querySelector("[data-quit]")?.addEventListener("click", (ev) => {
    ev.stopPropagation();
    handlers.onQuit();
  });
}

export function clearMenuModal(modal: HTMLElement): void {
  modal.hidden = true;
  modal.style.pointerEvents = "none";
  modal.innerHTML = "";
}
